"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssertionException = exports.RuntimeException = void 0;
const base_1 = require("./base");
/**
 * @export
 * @class RuntimeException
 * @extends {Exception}
 */
class RuntimeException extends base_1.Exception {
}
exports.RuntimeException = RuntimeException;
/**
 * @export
 * @class AssertionException
 * @extends {Exception}
 */
class AssertionException extends RuntimeException {
}
exports.AssertionException = AssertionException;
//# sourceMappingURL=runtime.js.map